module.exports = __webpack_public_path__ + "static/media/enterpriseLogo-inactive.a7047904.svg";